import { render, staticRenderFns } from "./ProviderDialog.vue?vue&type=template&id=47c67cc1"
import script from "./ProviderDialog.vue?vue&type=script&lang=js"
export * from "./ProviderDialog.vue?vue&type=script&lang=js"
import style0 from "./ProviderDialog.vue?vue&type=style&index=0&id=47c67cc1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports